import { isYoutubeNativeStation } from '../helpers';
import { useStations } from './useStations';
import { Station } from '@app/core/types/stations';

/** Stations that use the YouTube Native integration. */
export function useYoutubeNativeStations(): readonly Station[] {
  return useStations(isYoutubeNativeStation);
}
